import type { ReactNode } from 'react'

import { cn } from '@joyful/utils'

import { Tabular, badgeVariants } from '../../../../core'

export interface NavigationItemBadgeProps {
  'aria-label': string
  children: ReactNode
}

export function NavigationItemBadge({
  'aria-label': ariaLabel,
  children,
}: NavigationItemBadgeProps) {
  const classNames = badgeVariants({
    rounding: 'full',
    size: 'xs',
    variant: 'brand',
  })

  return (
    <span
      aria-label={ariaLabel}
      className={cn(
        classNames.base(),
        'h-5 min-w-5 shrink-0 justify-center px-1.5 py-0 leading-none',
      )}
    >
      <Tabular asChild size="inherit" weight="medium">
        <span className="text-box-cap">{children}</span>
      </Tabular>
    </span>
  )
}
